import { useCallback } from "react";
import { useAppTreeLocalState } from "../../../contexts/appTreeLocalStateContext.js";
import { useStores } from "../../../store/rootStore.js";
function useSortHandlers() {
    const { treeStore } = useStores();
    const { setShowProFeature } = useAppTreeLocalState();
    const handleSort = useCallback(async ({ id, oldIndex, newIndex, parentFromId, parentToId, nextId, source })=>{
        if (process.env.PLUGIN_CTX === "lite" && parentToId !== treeStore.rootId) {
            if (source === "dialog") {
                setShowProFeature("subfolder");
                return false;
            }
            treeStore.handleSort({
                id: +id,
                oldIndex,
                newIndex,
                parentFromId: +parentFromId,
                parentToId: +parentToId,
                nextId: nextId !== undefined ? +nextId : NaN,
                request: false
            });
            treeStore.handleSort({
                id: +id,
                oldIndex: newIndex,
                newIndex: oldIndex,
                parentFromId: +parentToId,
                parentToId: +parentFromId,
                nextId: NaN,
                request: false
            });
            setShowProFeature("subfolder");
            return false;
        }
        await treeStore.handleSort({
            id: +id,
            oldIndex,
            newIndex,
            parentFromId: +parentFromId,
            parentToId: +parentToId,
            nextId: nextId !== undefined ? +nextId : NaN
        });
        return true;
    }, [
        treeStore,
        setShowProFeature
    ]);
    return {
        handleSort
    };
}
export { useSortHandlers };
